<script lang="ts" setup>
import type { MarkdownRoot } from '@nuxt/content';
import { textContent, visit } from 'minimark';

const props = defineProps<{
  data: MarkdownRoot;
}>();

const questions: { name: string; acceptedAnswer: string }[] = [];

visit(
  props.data,
  (node) => node[0] === 'collapse',
  (node) => {
    questions.push({
      name: node[1].title,
      acceptedAnswer: textContent(node[2]).replace(/\n+/g, ' '),
    });
  },
);

if (questions.length) {
  useSchemaOrg([
    defineWebPage({
      '@type': 'FAQPage',
    }),
    ...questions.map((q) =>
      defineQuestion({
        name: q.name,
        acceptedAnswer: q.acceptedAnswer,
      }),
    ),
  ]);
}
</script>

<template>
  <slot />
</template>
